import type React from 'react';

import { Alert, Button } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core-react/i18n';

import { usePetitionActionsPageData } from '#src/app/pages/actions/pageContext';
import { useCampaignTracking } from '#src/app/shared/hooks/campaignTracking';

export const SignToAddVideo: React.FC = () => {
	const {
		data: {
			petition: { slug },
		},
	} = usePetitionActionsPageData();
	const { track } = useCampaignTracking();

	return (
		<>
			<Alert variant="info" heading={<Translate value="corgi.petition_actions.invite.signature_needed.title" />}>
				<Translate value="corgi.petition_actions.invite.signature_needed.message" />
			</Alert>
			<Button
				as="a"
				href={`/p/${slug}`}
				variant="secondary"
				onClick={() => {
					track('campaign_action_back_to_petition_click');
				}}
				className="w-full md:w-1/2"
				data-testid="sign-to-add-video"
				data-qa="sign-to-add-video"
			>
				<Translate value="corgi.petition_actions.invite.signature_needed.petition_link" />
			</Button>
		</>
	);
};
